import { useEffect, useState } from "react";
import { ReportInfo } from "@shared/interfaces/ReportsFiles";
import { useParams } from "react-router-dom";
import { useReport } from "@utils/useReports";

export const useProjectReportsTab = (
  activeTab: string,
  dropdownFilter: "Latest" | "Oldest",
  currentPage: number,
  reportsPerPage: number
) => {
  const { projectId, sharedToken } = useParams();
  const { getReports } = useReport();

  const [reports, setReports] = useState<ReportInfo[]>([]);
  const [loadingReports, setLoadingReports] = useState(true);
  const [totalCount, setTotalCount] = useState<number>(0); // For pagination

  useEffect(() => {
    if (activeTab !== "Reports") return;

    const fetchReports = async () => {
      setLoadingReports(true);
      try {
        if (!projectId) return;

        const offset = (currentPage - 1) * reportsPerPage;
        const order = dropdownFilter.toLowerCase(); // latest | oldest

        const response = await getReports(
          projectId,
          {
            order,
            offset,
            limit: reportsPerPage,
          },
          sharedToken
        );

        setReports(response.reports);
        setTotalCount(response.total_count);
      } catch (error) {
        console.error("Error fetching reports:", error);
        setReports([]);
      } finally {
        setTimeout(() => {
          setLoadingReports(false);
        }, 500);
      }
    };

    fetchReports();
  }, [activeTab, projectId, dropdownFilter, currentPage, reportsPerPage]);

  return { reports, loadingReports, totalCount };
};
